import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const TrackERed = ({ state, workState, onLabelClick }) => (
	<g id="TrackERed"
		 transform="translate(1490.000000, 875.000000)"
		 className="track"
	>
		<path
			d="M0.147414489,0.638120872 C6.8639649,5.42228359 11.4755111,8.71877724 13.9820532,10.5276018 M22.6312004,16.8610849 C31.8465373,23.7864209 38.1804947,29.0435495 41.6330726,32.6324707 C50.2924166,41.6337746 88.4063551,39.4245639 109.245926,37.4359477 C123.138974,36.1102035 136.772803,47.5109279 150.147414,71.6381209"
			stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)} strokeWidth={tracksWidth}
			strokeLinecap="round"/>

		<TrackArrow
			transform="translate(12.218926, 9.304034) rotate(-141.000000) translate(-12.218926, -9.304034) "
			points="16.2189261 17.3040344 8.21892612 9.30403438 16.2189261 1.30403438"
			strokeColor={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}/>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'TrackERed')}
			coords="25.748977, 12.638121"
			text='E'
			textCoordsX={'14.5249023'}
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
		/>
	</g>
);

TrackERed.propTypes = trackPropTypes;

export default TrackERed;
